module.exports = __webpack_public_path__ + "static/media/builtinv2-wifi broken.1fbb94fe.png";